import { AfterViewInit, ChangeDetectionStrategy, Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { isNullOrUndefined } from '@sla-ng/core';
import { Moment } from 'moment';
import { debounceTime, distinctUntilChanged, Observable, Subject, takeUntil } from 'rxjs';
import { map } from 'rxjs/operators';
import { IMovingAveragePrice } from '../../../models/moving-average-price.model';
import { TransactionalDataFacade } from '../../../services/facades/external-data/transactional-data-facade';
import { ITransactionalDataState } from '../../../services/facades/external-data/transactional-data.state.model';

@Component({
    templateUrl: './moving-average-price.page.html',
    styleUrls: [ './moving-average-price.page.scss' ],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class MovingAveragePricePage implements OnInit, AfterViewInit, OnDestroy {

    @ViewChild(MatSort)
    public sort: MatSort;

    @ViewChild(MatPaginator)
    public paginator: MatPaginator;

    public dataSource: MatTableDataSource<IMovingAveragePrice> = new MatTableDataSource<IMovingAveragePrice>([]);
    public transactionalDataState$: Observable<ITransactionalDataState>;
    public datefilterFormGroup: FormGroup = new FormGroup({ start: new FormControl<Moment>(null), end: new FormControl<Moment>(null) });
    private destroy$: Subject<void> = new Subject();

    constructor(private myTransactionalDataFacade: TransactionalDataFacade) {
    }

    public ngOnInit(): void {
        this.transactionalDataState$ = this.myTransactionalDataFacade.subState();
        this.transactionalDataState$
            .pipe(
                takeUntil(this.destroy$),
                map((s: ITransactionalDataState) => s.movingAveragePrices),
                distinctUntilChanged((prev, curr) => JSON.stringify(prev) === JSON.stringify(curr)))
            .subscribe((data: IMovingAveragePrice[]) => {
                this.dataSource.data = data;
            });
        this.datefilterFormGroup.valueChanges.pipe(debounceTime(500)).subscribe((daterange: { start: Moment, end: Moment }) => {
            if (!isNullOrUndefined(daterange.start) && !isNullOrUndefined(daterange.end)) {
                this.myTransactionalDataFacade.setDateRange(daterange);
                void this.myTransactionalDataFacade.fetchMovingAveragePrices();
            }
        });

        // Initialize the datepicker with the daterange from the state
        const state: ITransactionalDataState = this.myTransactionalDataFacade.getStateSnapshot();
        this.datefilterFormGroup.setValue(state.selectedDateRange);
    }

    public ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
        // Remove Sales from memory
        this.myTransactionalDataFacade.clearMovingAveragePrices();
    }

    public ngAfterViewInit(): void {
        this.dataSource.sort = this.sort;
        this.dataSource.paginator = this.paginator;
    }

    public applyFilter(filterValue: string): void {
        filterValue = filterValue.trim(); // Remove whitespace
        filterValue = filterValue.toLowerCase(); // MatTableDataSource defaults to lowercase matches
        this.dataSource.filter = filterValue;
    }

}
